module.exports = __webpack_public_path__ + "static/media/drone_marker.f5396390.svg";